module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_8003.c101d009.png";